<template>
  <div>
    <div class="ui styled attached accordion" style="width: 100%" v-if="prescriptions.length">
      <div 
        v-for="(prescription, prescriptionIndex) in prescriptions"
        @click="objectsToggleActive(prescriptionIndex, prescription.object)"
        :key="prescriptionIndex"
      >
        <div v-if="prescription.object"> 
          <div class="title">
            <i class="dropdown icon"></i>
            {{ timeFormat(prescription.object.created_at) }}
          </div>
          <div 
            class="content"
            :class="{ active: choosenObjectIndex === prescriptionIndex  || selectedObject.id === prescription.object.id }"
          >
            <abstractTable 
              :columns="prescriptionColumns" 
              :data="apiPrescriptionItems(prescription)"
              :classes="'ui very compact left aligned celled table'"
              v-if="prescription && prescription.prescription_items.length > 0 "
            />
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No prescription has been added yet
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    prescriptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      choosenObjectIndex: null,
      selectedObject: {}
    }
  },
  computed: {
    prescriptionColumns () {
      return [
        { header: this.$t('medicine'), fieldName: 'medicine', show: true, width: '15%' },
        { header: this.$t('description'), fieldName: 'description', show: true }
      ]
    },
  },
  methods: {
    objectsToggleActive (index, choosenObject) {
      this.choosenObjectIndex = this.choosenObjectIndex === index
        ? null : index

      this.selectedObject !== {} && this.selectedObject.id === choosenObject.id
        ? this.selectedObject = {} : this.selectedObject = choosenObject
    },
    timeFormat (time) {
      return window.moment(time).format('LLLL')
    },
    apiPrescriptionItems (prescription) {
      let formalatedPrescriptionItems = []

      window._.each(prescription.prescription_items, prescriptionItem => {
        formalatedPrescriptionItems.push({
          medicine: prescriptionItem.medicine_name,
          description: prescriptionItem.description
        })
      })

      return formalatedPrescriptionItems
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/medical_history_components/Prescriptions.vue